import { render, staticRenderFns } from "./ProductListDetails.vue?vue&type=template&id=0d88b757&"
import script from "./ProductListDetails.vue?vue&type=script&lang=js&"
export * from "./ProductListDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports